<div class="up-backdrop" [attr.data-theme]="'pxlvd'">
  <div class="up-card">

    <div class="up-logo">
      <span class="logo-pxl">pxl</span><span class="logo-vd">vd</span>
    </div>

    <h2 class="up-title">Choose your username</h2>
    <p class="up-sub">This is how other collaborators will see you. You can change it later.</p>

    <div class="up-field">
      <div class="up-input-wrap">
        <span class="up-at">@</span>
        <input
          class="up-input"
          type="text"
          [(ngModel)]="username"
          (ngModelChange)="onInput()"
          (keydown.enter)="onConfirm()"
          placeholder="yourname"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="false"
          autofocus
          maxlength="30">
        <span class="up-spinner" *ngIf="checkState === 'checking'"></span>
      </div>
      <p class="up-hint" [class]="hintClass" *ngIf="checkState !== 'idle'">{{ hintText }}</p>
      <p class="up-hint hint-err" *ngIf="errorMsg">{{ errorMsg }}</p>
    </div>

    <p class="up-rules">3–30 characters · letters, numbers, _ and - only</p>

    <button class="up-btn" [class.loading]="saving" [disabled]="!canConfirm" (click)="onConfirm()">
      <span *ngIf="!saving">Claim @{{ username || 'username' }}</span>
      <span *ngIf="saving" class="up-spinner-btn"></span>
    </button>

  </div>
</div>
